import { render, staticRenderFns } from "./AppliedPmtaConfigs.vue?vue&type=template&id=56abca65&scoped=true"
import script from "./AppliedPmtaConfigs.vue?vue&type=script&lang=js"
export * from "./AppliedPmtaConfigs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56abca65",
  null
  
)

export default component.exports